var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('AutocompleteField',_vm._g(_vm._b({attrs:{"label":"Pracodawca","items":_vm.items,"loading":_vm.itemsLoading}},'AutocompleteField',_vm.$attrs,false),_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }